import axios from 'axios';
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const functionHandle = createAsyncThunk('function', async () => {
	const response = await axios.get('/manage/constant/functions');
	
	return response;
});

export const functionSlice = createSlice({
    name: 'function',
    initialState: {
		functions: null
    },
	reducers: {
		resetState: (state, props) => {
			state.functions = null;
		}
	},
    extraReducers: builder => {
		builder.addCase(functionHandle.fulfilled, (state, { payload }) => {
			state.functions = payload;
		})
    }
})

export const { resetState } = functionSlice.actions;
export default functionSlice.reducer;
